var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrecipitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "drop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "drop_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0008 28.0031C38.0008 24.9221 35.6293 20.3795 31.597 15.0759C29.08 11.7654 26.238 8.56841 23.9831 6.26356C21.7452 8.55455 18.8983 11.7648 16.3881 15.0749C12.3663 20.3782 10.0008 24.9213 10.0008 28.0031C10.0008 31.4872 11.2755 34.7693 13.545 37.3135C13.9127 37.7256 13.8766 38.3577 13.4645 38.7254C13.0524 39.093 12.4202 39.057 12.0526 38.6448C9.45902 35.7375 8.00079 31.9827 8.00079 28.0031C8.00079 24.3399 10.5179 19.5057 14.7945 13.8664C17.5313 10.2576 20.6462 6.77936 23.0017 4.41004C23.5482 3.86352 24.4174 3.86352 24.9656 4.41178C27.3412 6.79897 30.4471 10.259 33.1891 13.8654C37.4772 19.5054 40.0008 24.3394 40.0008 28.0031C40.0008 36.8394 32.8371 44.0032 24.0008 44.0032C20.9637 44.0032 18.0493 43.1555 15.5341 41.5807C15.066 41.2877 14.9241 40.6706 15.2172 40.2025C15.5103 39.7344 16.1273 39.5925 16.5955 39.8856C18.7944 41.2623 21.3415 42.0032 24.0008 42.0032C31.7325 42.0032 38.0008 35.7349 38.0008 28.0031ZM14 28.3776C14 33.8993 18.4783 38.3775 24 38.3775C24.5523 38.3775 25 38.8253 25 39.3775C25 39.9298 24.5523 40.3775 24 40.3775C17.3737 40.3775 12 35.0038 12 28.3776C12 27.8253 12.4477 27.3776 13 27.3776C13.5523 27.3776 14 27.8253 14 28.3776Z",
    fill: "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrecipitation);
export default __webpack_public_path__ + "static/media/precipitation.78030be511619ddc4d0991df10414fdc.svg";
export { ForwardRef as ReactComponent };